import { SortTypeEnum } from 'src/app/shared/search-request-dto';

export class SearchOptions {
    timeout: number = 30000;
    highlight: boolean = true;
    size: number = 25;
    page: number = 0;
    from: number = 0;
    sortField: string = null;
    sortType: SortTypeEnum = SortTypeEnum.DESC;
    timeSort: boolean = false;
}